import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-recruit_index_back",
  "use": "icon-recruit_index_back-usage",
  "viewBox": "0 0 44 45",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 45\" id=\"icon-recruit_index_back\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#F5F5F5\" d=\"M-34-59h750v2393H-34z\" /><path fill=\"#4A88F7\" d=\"M-34-59h750V69H-34z\" /><path d=\"M32.24 5.745a1.333 1.333 0 1 0-1.814-1.954L11.76 21.124a1.333 1.333 0 0 0 0 1.955l18.667 17.333a1.333 1.333 0 0 0 1.815-1.954L14.626 22.1 32.241 5.745z\" fill=\"#FFF\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol